import React from "react";
import Heading from "../common/heading/Heading";
import "../about/about.css";
import { homeAbout } from "../../dummydata";
import Awrapper from "../about/Awrapper";
import Abimg from "../../img/boy-rising-hand-class.jpg";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <>
      <section className="aboutHome">
        <div className="container flexSB ">
          <div className="left row">
            <img src="./aboutImg.jpg" alt="bethanybils" />
          </div>
          <div className="right row">
            <Heading
              subtitle="A Family Of Learning"
              title="Master the German Language with BILS"
            />
            <div className="items">
              {homeAbout.slice(0, 3).map((val) => {
                return (
                  <div className="item flexSB flexSB1" key={val.id}>
                    <div className="img">
                      <img src={val.cover} alt="" />
                    </div>
                    <div className="text">
                      <h2>{val.title}</h2>
                      <p>{val.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      {/* <Awrapper /> */}
    </>
  );
};

export default About;
